import { useMatches } from 'react-router'

import { type AppRouteHandle } from '~/shell/app/registry'

/** The `appId` a matched route carries, if it carries one. */
const appIdOf = (handle: unknown): string | undefined =>
  (handle as AppRouteHandle | undefined)?.appId

/**
 * The id of the app the current route belongs to, or `undefined` outside any app (the bootstrap
 * index, `/unauthorized`, `/launch`).
 *
 * Read from the matched routes rather than parsed out of the pathname, so it cannot disagree with
 * what actually rendered: the id travels on the route that matched (see `mountedAppRoutes`). This
 * is the shell's only route to the active app, because a literal mount segment means there is no
 * `:app` param to read. See Atlas ADR-0014.
 */
export const useActiveApp = (): string | undefined => {
  const matches = useMatches()

  return matches.reduce<string | undefined>(
    (found, match) => appIdOf(match.handle) ?? found,
    undefined,
  )
}
